"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaItemList = void 0;
var react_1 = require("@chakra-ui/react");
var React = __importStar(require("react"));
var MediaContext_1 = require("../MediaContext");
var MediaItem_1 = require("../MediaItem");
var UploadingMediaItemCard_1 = require("./UploadingMediaItemCard");
var MediaItemCard_1 = require("./MediaItemCard");
var MediaAlerts_1 = require("./MediaAlerts");
var MediaItemListFilters_1 = require("./MediaItemListFilters");
var SkeletonMediaItemCard_1 = require("./SkeletonMediaItemCard");
var Icon_1 = require("../../Icon");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var ClearAllMediaButton_1 = require("./ClearAllMediaButton");
var useSimpleDragDrop_1 = require("../useSimpleDragDrop");
var MediaItemFilterName_1 = require("../MediaItemFilterName");
function MediaItemList(_a) {
    var _this = this;
    var onClose = _a.onClose, onSelect = _a.onSelect;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    var _b = React.useState({
        tab: (0, MediaItemFilterName_1.tabFromFilter)(),
        sortBy: MediaItemFilterName_1.MediaSorts.Date,
    }), filters = _b[0], setFilters = _b[1];
    var mediaItems = mediaContext.mediaItems;
    var uploadingMediaItems = mediaItems.filter(MediaItem_1.isUploadingMediaItem);
    var loadedMediaItems = mediaItems.filter(MediaItem_1.isNotUploadingMediaItem);
    var _c = React.useState(null), ineligibleMediaItem = _c[0], setIneligibleMediaItem = _c[1];
    var _d = (0, useSimpleDragDrop_1.useSimpleDragDrop)(), dragActive = _d.dragActive, onHandleDrag = _d.onHandleDrag, onHandleDrop = _d.onHandleDrop;
    loadedMediaItems = loadedMediaItems.filter(function (mediaItem) {
        if (filters.tab === MediaItemFilterName_1.MediaTabs.Images) {
            return (0, MediaItem_1.isGuideImage)(mediaItem);
        }
        if (filters.tab === MediaItemFilterName_1.MediaTabs.Documents) {
            return (0, MediaItem_1.isDocument)(mediaItem);
        }
        if (filters.tab === MediaItemFilterName_1.MediaTabs.Media) {
            return (0, MediaItem_1.isGuideVideoObject)(mediaItem);
        }
        return true;
    });
    if (filters.sortBy === MediaItemFilterName_1.MediaSorts.AZ) {
        loadedMediaItems = loadedMediaItems.sort(function (a, b) { return a.filename.localeCompare(b.filename); });
    }
    else {
        loadedMediaItems = loadedMediaItems.sort(function (a, b) { return b.date - a.date; });
    }
    var filteredMediaItems = __spreadArray(__spreadArray([], uploadingMediaItems, true), loadedMediaItems, true);
    var handleOnSelect = function (mediaItem) { return __awaiter(_this, void 0, void 0, function () {
        var selectedImage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIneligibleMediaItem(null);
                    if (!!(0, MediaItem_1.isUploadingMediaItem)(mediaItem)) return [3 /*break*/, 3];
                    if (!((0, MediaItem_1.isGuideImage)(mediaItem) && mediaItem.filter_state === 'crop')) return [3 /*break*/, 2];
                    return [4 /*yield*/, mediaContext.cropGuideImageToRatio(mediaItem)];
                case 1:
                    selectedImage = _a.sent();
                    if (selectedImage) {
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedImage);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    if (mediaItem.filter_state === false) {
                        setIneligibleMediaItem(mediaItem);
                    }
                    else if (mediaItem.filter_state) {
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect(mediaItem);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.ModalHeader, null,
            React.createElement(react_1.Flex, { justify: "space-between", position: "relative" },
                React.createElement(react_1.Heading, { display: { base: 'none', lg: 'block' }, position: "absolute", textAlign: "center", width: "100%", 
                    // Resetting styles that get applied in the monolith
                    borderBottom: "none", m: 0 }, _js('Media Manager')),
                React.createElement(react_1.Button, { variant: "cta", onClick: function () { return mediaContext.setView('upload'); }, leftIcon: React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faUpload }), "data-feature-id": "media_manager_view_upload" }, _js('Upload Media')),
                React.createElement(react_1.Button, { onClick: onClose, rightIcon: React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faClose }) }, _js('Exit')))),
        React.createElement(react_1.ModalBody, { p: "0", flex: 1, display: "flex", flexDirection: "column", minH: 0, onDragEnter: onHandleDrag, onDragLeave: onHandleDrag, onDragOver: onHandleDrag, onDrop: onHandleDrop, backgroundColor: dragActive ? 'blue.100' : 'white' },
            React.createElement(MediaItemListFilters_1.MediaItemListFilters, { filters: filters, setFilters: setFilters }),
            ineligibleMediaItem && (React.createElement(MediaAlerts_1.MediaAlerts, { onCancel: function () { return setIneligibleMediaItem(null); }, mediaItem: ineligibleMediaItem })),
            !mediaContext.isLoadingMediaItems && filteredMediaItems.length === 0 && (React.createElement(react_1.Flex, { minH: "inherit", direction: "column", align: "center", justify: "center", gap: "4", flex: 1 },
                React.createElement(react_1.Text, { textAlign: "center", fontSize: "3xl", fontWeight: "bold" }, _js('Your media manager is empty')),
                React.createElement(react_1.Text, { textAlign: "center", fontSize: "xl" }, _js('Add new files by dragging & dropping, uploading, or pasting them from your clipboard.')),
                React.createElement(react_1.Button, { variant: "cta", onClick: function () { return mediaContext.setView('upload'); }, "data-feature-id": "media_manager_view_upload" }, _js('Upload Media')))),
            (mediaContext.isLoadingMediaItems || filteredMediaItems.length > 0) && (React.createElement(react_1.Box, { flex: 1, overflowY: "auto", minH: 0 },
                React.createElement(react_1.Flex, { gap: "4", flexWrap: "wrap", paddingX: "24px" },
                    mediaContext.isLoadingMediaItems && (React.createElement(React.Fragment, null,
                        React.createElement(SkeletonMediaItemCard_1.SkeletonMediaItemCard, null),
                        React.createElement(SkeletonMediaItemCard_1.SkeletonMediaItemCard, null),
                        React.createElement(SkeletonMediaItemCard_1.SkeletonMediaItemCard, null),
                        React.createElement(SkeletonMediaItemCard_1.SkeletonMediaItemCard, null))),
                    !mediaContext.isLoadingMediaItems &&
                        filteredMediaItems.length > 0 &&
                        filteredMediaItems.map(function (mediaItem) {
                            return (0, MediaItem_1.isNotUploadingMediaItem)(mediaItem) ? (React.createElement(MediaItemCard_1.MediaItemCard, { key: mediaItem.imageid, mediaItem: mediaItem, onSelect: onSelect ? function () { return handleOnSelect(mediaItem); } : undefined })) : (React.createElement(UploadingMediaItemCard_1.UploadingMediaItemCard, { key: mediaItem.tempId, mediaItem: mediaItem, mediaContext: mediaContext }));
                        }))))),
        React.createElement(react_1.ModalFooter, { w: "100%" },
            React.createElement(react_1.Flex, { justify: "space-between", flex: 1, align: "center" },
                React.createElement(react_1.Text, null, _js('%1 items', "".concat(mediaContext.mediaItems.length))),
                React.createElement(ClearAllMediaButton_1.ClearAllMediaButton, null)))));
}
exports.MediaItemList = MediaItemList;
